import clsx from 'clsx'

interface ComplianceScoreProps {
  score: number
}

export default function ComplianceScore({ score }: ComplianceScoreProps) {
  const percentage = Math.round(score * 100)
  const circumference = 2 * Math.PI * 120
  const strokeDashoffset = circumference - (score * circumference)

  const getScoreColor = () => {
    if (score >= 0.9) return 'text-green-500'
    if (score >= 0.7) return 'text-yellow-500'
    return 'text-red-500'
  }

  const getStrokeColor = () => {
    if (score >= 0.9) return '#10B981'
    if (score >= 0.7) return '#F59E0B'
    return '#EF4444'
  }

  const getScoreLabel = () => {
    if (score >= 0.9) return 'Excellent'
    if (score >= 0.7) return 'Good'
    if (score >= 0.5) return 'Fair'
    return 'Poor'
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Platform Compliance Score
      </h3>

      <div className="flex items-center justify-center">
        <div className="relative">
          <svg className="w-64 h-64 transform -rotate-90">
            {/* Background circle */}
            <circle
              cx="128"
              cy="128"
              r="120"
              stroke="#E5E7EB"
              strokeWidth="16"
              fill="none"
            />
            {/* Progress circle */}
            <circle
              cx="128"
              cy="128"
              r="120"
              stroke={getStrokeColor()}
              strokeWidth="16"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="transition-all duration-1000 ease-out"
            />
          </svg>

          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className={clsx('text-6xl font-bold', getScoreColor())}>
              {percentage}%
            </span>
            <span className="text-lg font-medium text-gray-600 mt-2">
              {getScoreLabel()}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-3 gap-4">
        <div className="text-center">
          <p className="text-sm font-medium text-gray-600">Target</p>
          <p className="text-lg font-bold text-gray-900">95%</p>
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-gray-600">Best</p>
          <p className="text-lg font-bold text-green-600">97%</p>
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-gray-600">Worst</p>
          <p className="text-lg font-bold text-red-600">68%</p>
        </div>
      </div>
    </div>
  )
}